<template>
  <div v-if="company && !loading">
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">Edition de la société {{company.name}}</span>
    </sticky>
    <div class="columns is-gapless is-margin-left-on-btn-actions is-margin-right-on-btn-actions is-padding-top">
      <div class="column is-12 is-9-widescreen is-8-fullhd">
        <div class="has-bg-white is-border">
          <company-form @submit="submit" :source="company" :loading="loading"></company-form>
        </div>
      </div>
    </div>
  </div>
  <spinner-round v-else :isLoading="loading"></spinner-round>
</template>

<script>
  import CompanyForm from '@/components/company/CompanyForm'

  export default {
    name: 'CompanyCreate',
    data () {
      return {
        loading: true,
        company: null
      }
    },
    components: {
      CompanyForm
    },
    created () {
      this.getCompany(this.$route.params.id)
    },
    methods: {
      getCompany (id) {
        this.loading = true
        this.$api.companyService.getOne(id).then(res => {
          this.loading = false
          this.company = res.data
        }).catch(() => {
          this.loading = false
        })
      },
      submit (company, redirect) {
        this.loading = true
        this.$api.companyService.put(company.pk, company).then(res => {
          this.company = res.data
          this.loading = false
          this.$notify({
            type: 'is-success',
            text: 'La société a été mise à jour'
          })
          if (redirect) {
            this.$router.push({name: 'CompanyVue', params: {id: res.data.pk}})
          }
        }).catch(() => {
          this.loading = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la mise à jour de la société.'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/company/CompanyEdit.vue